import { useEffect, useState } from 'react'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';

import './style.scss';
import { UserPost } from '../../types/posts';
import AppUserPost from '../../components/app_userPost/AppUserPost';

function AppProfileUser() {

	const [usersName, setUsersName] = useState<string>('')
	const [bioExpanded, setBioExpanded] = useState<boolean>(false)
	const [bioText, setBioText] = useState<string>('')
	const [userIsVerified, setUserIsVerified] = useState<boolean>(true)

	const [showingReels, setShowingReels] = useState<boolean>(true)

	const [userPosts, setUserPosts] = useState<UserPost[]>([])

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn === false) {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		} else {
			// Load profile data
			// setBioText('Thisis the users Bio section where they can write a little about who they are. The text will appears cut off until it is expanded by clicking the show more button')
			getProfileData()
		}
	}, [])

	const getProfileData = () => {
		setUsersName(userStateData.getUsersName())
		const bioStr: string = userStateData.getAboutText() || ''
		setBioText(bioStr)
		setUserIsVerified(true)

		// Fake post
		// const fakePost: UserPost = {
		// 	postId: '6666',
		// 	sourceName: 'Test User',
		// 	community: 'Community Name',
		// 	sourceImgSrc: userStateData.getUserIconUrl() || '',
		// 	postDate: 0,
		// 	postMsg: 'This is an example fake post used for testing the front end layout',
		// 	postImgSrc: undefined,
		// 	verified: true
		// }
		// const fakePost2: UserPost = {
		// 	postId: '66626',
		// 	sourceName: 'Test User',
		// 	community: 'Community Name',
		// 	sourceImgSrc: userStateData.getUserIconUrl() || '',
		// 	postDate: 0,
		// 	postMsg: 'This is an example fake post with an image',
		// 	postImgSrc: userStateData.getUserIconUrl(),
		// 	verified: true
		// }
		// const fakePost3: UserPost = {
		// 	postId: '6666',
		// 	sourceName: 'Test User',
		// 	community: 'Community Name',
		// 	sourceImgSrc: userStateData.getUserIconUrl() || '',
		// 	postDate: 0,
		// 	postMsg: 'Another fake post to test stacked posts in layout',
		// 	postImgSrc: undefined,
		// 	verified: true
		// }
		const fakePost: UserPost = {
			postId: '6666',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'This is an example fake post used for testing the front end layout',
			postImgSrc: undefined,
			verified: true
		}
		const fakePost2: UserPost = {
			postId: '66626',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'This is an example fake post with an image',
			postImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl(),
			verified: true
		}
		const fakePost3: UserPost = {
			postId: '6666',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'Another fake post to test stacked posts in layout',
			postImgSrc: undefined,
			verified: true
		}
		setUserPosts([fakePost, fakePost2, fakePost3])
	}

	return (
		<>
			<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space app-profile-user-full-section'>
				<div className='app-profile-user-top-section-wrap'>
					<div className='app-profile-user-top-section'>
						<div className='app-profile-user-top-section-cover-image' />
						<div
							className='app-profile-user-img-wrap'
							// href={PAGE_URLS.DASHBOARD_CUSTOMER}
						>
							<img 
								className='app-profile-user-img'
								src={userStateData.getUserIconUrl()}
								alt='Profile'
							/>
						</div>
					</div>
				</div>
				<div className='app-profile-user-bio-section-wrap'>
					<div className='app-profile-user-top-name-wrap'>
						<div className='app-profile-user-top-name'>{usersName}</div>
						{userIsVerified && 
							<img
								className='app-profile-user-verify-tick'
								src='/imgs/icons/profile/icon-profile-verified-tick.svg'
								alt='Verified tick'
							/>
						}
						<div className='app-profile-user-top-name-button'>
							<div className='app-profile-user-top-name-button-label'>Friend</div>
						</div>
					</div>
					<div className='app-profile-user-friend-wrap'>
						<div className='app-profile-user-friend-icon' />
						<div className='app-profile-user-friend-icon' />
						<div className='app-profile-user-friend-icon' />
						<div className='app-profile-user-friend-label'>+ Friends</div>
						<div className='app-profile-user-public-wrap'>
							<img
								className='app-profile-user-public-img'
								alt='Public icon'
								src='/imgs/icons/profile/icon-profile-public.svg'
							/>
							<div className='app-profile-user-public-label'>Public</div>
						</div>
					</div>
					<div 
						// className={`app-profile-user-bio-wrap ${bioExpanded ? 'app-profile-user-bio-expanded' : ''}`}
						className='app-profile-user-bio-text'
					>
						{bioText.length > 1 ? 
							<>
								{bioExpanded ? bioText : `${bioText.substring(0, 20)} ... `}
								{bioExpanded === false && 
									<div 
										className='app-profile-user-bio-show-more'
										onClick={() => {
											setBioExpanded(true)
										}}
									>see more</div>
								}
							</> :
							<>No Bio Provided</>
						}
					</div>
					<div className='app-profile-user-switch-wrap'>
						<div 
							className={`app-profile-user-switch-button ${showingReels === true ? 'app-profile-user-switch-button-selected' : ''}`}
							onClick={() => {
								setShowingReels(true)
							}}
						>
							<img 
								className='app-profile-user-switch-img'
								src={`/imgs/icons/profile/icon-profile-icon-reel-${showingReels === true ? 'active' : 'inactive'}.svg`}
								alt='reel switch'
							/>
						</div>
						{/* <div className='app-profile-user-switch-button'> */}
						<div 
							className={`app-profile-user-switch-button ${showingReels === false ? 'app-profile-user-switch-button-selected' : ''}`}
							onClick={() => {
								setShowingReels(false)
							}}
						>
							<img 
								className='app-profile-user-switch-img'
								// src='/imgs/icons/profile/icon-profile-icon-community-active.svg'
								src={`/imgs/icons/profile/icon-profile-icon-community-${showingReels === false ? 'active' : 'inactive'}.svg`}
								alt='community switch'
							/>
						</div>
					</div>
				</div>
				<div className='app-profile-user-content-section-wrap'>
					{showingReels ? 
						<>
							{userPosts.length > 0 ?
								userPosts.map((postData: UserPost, index: number) => <AppUserPost data={postData} key={`post${index}`} />)
								:
								<div className='app-profile-user-content-section-empty-text'>
									<div className='app-profile-user-content-section-empty-text-title'>You haven't posted anything yet...</div>
									<div className='app-profile-user-content-section-empty-text-sub-text'>Get started by going to communities<br/>and tapping the post button!</div>
								</div>
							}
						</>
						:
						<div className='app-profile-user-content-section-empty-text'>
							{/* <div className='app-profile-user-content-section-empty-text-title'>You haven't posted anything yet...</div> */}
							<div className='app-profile-user-content-section-empty-text-title'>You haven't joined yet...</div>
							<div className='app-profile-user-content-section-empty-text-sub-text'>Get started by going to communities<br/>and joining a group!</div>
						</div>
					}
				</div>
			</div>
			<BackToTopButton />
			<AppFooter activeIndex={4} />
		</>
	)
}

export default AppProfileUser
